module.exports = __webpack_public_path__ + "img/wish_04.4dcddb3c.png";